import { type UISortOption } from 'src/components/types/UISortOption';
import { type ReduxApplicationState } from 'src/redux/combinedReducer';
import { selectHash, selectPathname } from 'src/redux/navigation/selectors';
import { getSortOptionValue } from 'src/redux/productsQuery/helpers/getSortOptionValue';
import { adaptStoreToFilterPath, adaptStoreToPageURL } from './adaptStoreToPageURL';
import { buildListingsURL } from './buildListingsURL';
import { getListingsSortAsURLSearchParams } from './listings-api/getListingsSortAsURLSearchParams';

/**
 * Derives a URL href for each sort option based on current store state.
 * Each href preserves the current facet filters (as path segments) and search
 * term, resets pagination to page 1, and sets the `sort` param for that option
 * (or omits it for the default/empty-key sort option).
 */
export const adaptStoreToSortOptionHrefs = (state: ReduxApplicationState): UISortOption[] => {
  const { sortOptions } = state.productsQuery;

  // Filter path: current active facets as path segments (constant across all sort hrefs).
  const filterPath = adaptStoreToFilterPath(state);

  // Base query params: search term, page 1 (no page param). Sort is set per-option below.
  const baseParams = adaptStoreToPageURL(state, 1);
  baseParams.delete('sort');

  return sortOptions.map((option) => {
    const params = new URLSearchParams(baseParams);

    if (option.key) {
      getListingsSortAsURLSearchParams(params, option);
    }

    return {
      active: option.active,
      href: buildListingsURL(selectPathname(state), filterPath, params, selectHash(state)),
      title: option.title,
      value: getSortOptionValue(option),
    };
  });
};
